import postalCodesValidator from 'postal-codes-js'

export default {
  getMessage: () => 'Invalid code format for this country.',
  validate: (value, [countryCode]) =>
    postalCodesValidator.validate(countryCode, value) === true
}
